<script setup lang="ts">
import PageFeedback from '@/components/PageFeedback/PageFeedback.vue';
import { jobSeries } from '@/components/icons/icons';
import BasePage from '@/components/pages/BasePage/BasePage.vue';
import BasePageTitle from '@/components/pages/BasePage/BasePageTitle.vue';
</script>

<template>
  <BasePage>
    <template #title>
      <BasePageTitle :title="$t('NoPermissions')" />
    </template>
    <PageFeedback :icon="jobSeries" :message="$t('NoPermissionsForThisPage')" />
  </BasePage>
</template>
